import React from 'react';
import PropTypes from 'prop-types';

import greenBall from '@common/assets/images/virtualBalls/green.png';
import blueBall from '@common/assets/images/virtualBalls/blue.png';
import yellowBall from '@common/assets/images/virtualBalls/yellow.png';
import redBall from '@common/assets/images/virtualBalls/red.png';

const colorMap = {
  Green: greenBall,
  Blue: blueBall,
  Yellow: yellowBall,
  Red: redBall,
};

const VirtualsResultsPlayerName = ({ data, position }) => {
  const ballColor = [...data.scores.matchAll(/\d+\)\s\d+\s(\w+)/g)].map((match) => match[1])[position];
  const color = colorMap[ballColor];
  return (
    <div className="virtuals-row-result">
      {color && <img src={color} alt="virtual ball" />}
      <span>{data?.scores?.split(',')[position]?.split(')')[1]}</span>
    </div>
  );
};

VirtualsResultsPlayerName.propTypes = {
  data: PropTypes.object.isRequired,
  position: PropTypes.number.isRequired,
};

export default VirtualsResultsPlayerName;
